export default __webpack_public_path__ + "static/media/salary4.c79dc618.png";